<h3-settings-header [label]="label" (resetValue)="reset()"></h3-settings-header>
<mat-form-field class="input-field">
  <input
    matInput
    type="number"
    [min]="min"
    [step]="step"
    [ngModel]="settingStore.$ | async"
    (ngModelChange)="setValueAndTrackEvent($event)"
  />
</mat-form-field>
